
























import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop } from 'vue-property-decorator';
import { DamageStepType, IDamage, IDamageStep } from 'admiral-core';

import 'vue-select/dist/vue-select.css';
import { Util } from '@/utils/Util';
import Avatar from '@/components/common/Avatar.vue';
import { mixins } from 'vue-class-component';
import { FormatMixin } from '@/mixins/FormatMixin';

@Component({
  components: { Avatar },
})
export default class DamageTimeline extends mixins(FormatMixin) {
  @Prop({ required: true, type: Object })
  damage!: IDamage;

  timestampStr(damageStep: IDamageStep) {
    return Util.formatDate(damageStep.createdAt);
  }
  timestampFullStr(damageStep: IDamageStep) {
    return Util.formatDateFull(damageStep.createdAt);
  }

  get steps() {
    return (
      this.damage?.damageSteps?.sort((a: IDamageStep, b: IDamageStep) => {
        if (new Date(a.createdAt).getTime() >= new Date(b.createdAt).getTime()) {
          return -1;
        }
        return 1;
      }) ?? []
    );
  }

  timelinePointType(damageStep: IDamageStep) {
    switch (damageStep.type) {
      case DamageStepType.Comment:
        return 'timeline-point-secondary';
      case DamageStepType.Edited:
        return 'timeline-point-secondary';
      case DamageStepType.Created:
        return 'timeline-point-primary';
      case DamageStepType.TransitionNew:
        return 'timeline-point-primary';
      case DamageStepType.TransitionInProgress:
        return 'timeline-point-info';
      case DamageStepType.TransitionPending:
        return 'timeline-point-info';
      case DamageStepType.TransitionSubmitted:
        return 'timeline-point-warning';
      case DamageStepType.TransitionCompleted:
        return 'timeline-point-success';
      case DamageStepType.TransitionDeleted:
        return 'timeline-point-danger';
      case DamageStepType.TransitionArchived:
        return 'timeline-point-secondary';
      case DamageStepType.TransitionDeclined:
        return 'timeline-point-danger';
    }
  }
}
